import axios from 'axios'
import {
    COMMENTS_LIST_REQUEST,
    COMMENTS_LIST_SUCCESS,
    COMMENTS_LIST_FAILED,
} from './commentConstants'

export const listOfComments = (typeOfEntities, itemID, pageNumber = 1, isAdmin = false, token = '') => async (
    dispatch
) => {
    let res = []
    let adr = ''
    try {

        dispatch({ type: COMMENTS_LIST_REQUEST })

        if (isAdmin) {
            if (typeOfEntities === "products") {
                adr = `/api/admin/products/comments/`
                adr += '?productId=' + itemID
            }
            else if (typeOfEntities === "article") {
                adr = `/api/admin/articles/comments/`
                adr += '?ArticleId=' + itemID
            }
            adr += '&pageId=' + pageNumber
            const config = {
                headers: {
                    Authorization: `Bearer ` + token,
                },
            };
            const { data } = await axios.get(adr, config)
            res = data
        }
        else {
            if (typeOfEntities === "products") {
                adr = `/api/products/comments/`
                adr += '?productId=' + itemID
            }
            else if (typeOfEntities === "article") {
                adr = `/api/articles/comments/`
                adr += '?ArticleId=' + itemID
            }
            adr += '&pageId=' + pageNumber
            const { data } = await axios.get(adr)
            res = data

        }
        if (res.status === "ok") {

            dispatch({
                type: COMMENTS_LIST_SUCCESS,
                payload: res.data
            })

        }
        else {

            dispatch({
                type: COMMENTS_LIST_FAILED,
                payload: 'خطا در دریافت اطلاعات از سرور'
            })

        }
    } catch (error) {
        const err = error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        console.error(err);
        dispatch({
            type: COMMENTS_LIST_FAILED,
            payload: 'خطا در دریافت اطلاعات از سرور'
        })
    }
}


